<template>
  <div id="headline-media-cetak-page">
    <!-- page header component -->
    <div class="px-gap">
      <div
        class="bg-white rounded p-3 shade d-flex align-items-center mb-4"
        style="margin-top: 15px"
      >
        <div class="h3" style="font-size: 20px">
          <i class="bi bi-newspaper"></i>
          Headline Media Cetak Nasional pada Tanggal {{ today(date) }}
        </div>
        <div class="input-group ml-auto" style="width: 20rem">
          <multiselect
            v-model="selected_media"
            :options="media_options"
            :searchable="true"
            :allowEmpty="false"
            label="nama"
            track-by="nama"
            :disabled="is_load_media"
            @input="changeSelectedMedia"
            placeholder="Pilih Media"
          >
          </multiselect>
        </div>
      </div>
    </div>
    <!-- page component -->
    <transition name="block">
      <div class="px-gap" v-if="is_loading">
        <div class="bg-white rounded shade px-3 py-3">
          <loader-component />
        </div>
      </div>
      <div v-else>
        <div v-if="data.length > 0" class="px-gap">
          <div
            v-for="(item, index) in data"
            :key="index"
            class="m-t-10 bg-white rounded px-4 py-4 clickable shade mb-4"
            @click="showDetailModal(item)"
          >
            <div class="d-flex">
              <div style="width: 25%">
                <img
                  :src="item.file_source[0] || item.file_source"
                  class="rounded-lg border"
                  style="width: 100%; height: 12rem; object-fit: cover"
                  @error="imgError"
                />
              </div>
              <div class="ml-5" style="width: 75%">
                <div class="h5 text-justify hoverable">
                  {{ item.title }}
                </div>
                <div class="h6 mt-3">
                  <i class="bi bi-newspaper"></i>
                  <span> {{ item.account }} </span>
                  <i class="bi bi-calendar-event ml-5"></i>
                  <span> {{ dateindo(item.date.$date) }} </span>
                </div>
                <div class="mt-4 scroller" style="max-height: 20rem">
                  <p
                    v-html="writeContent(limitContent(item.content))"
                    style="font-size: 16px; text-align: justify"
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-5 mt-3 pb-1">
            <pagination-component
              v-if="page_info != null"
              :key="pagination_key"
              class="pull-right"
              :data="page_info"
              :goto="true"
            />
          </div>
        </div>
        <div v-else class="px-gap">
          <div class="bg-white rounded shade px-3 py-3">
            <div class="alert alert-danger text-center mb-0">
              <strong>Mohon maaf, data tidak tersedia!</strong> Silahkan lakukan
              pencarian dengan parameter lain
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- detail modal component -->
    <modal-detail-component
      v-if="isShowModalDetail"
      :id_stream="id_stream"
      :is_on_medmon="false"
      :props_data="child_data"
      :key="detail_key"
      @close="closeModalDetail"
    />
  </div>
</template>

<script>
import gp from "@/plugins/generalPlugins.js";
import loader from "@/views/components/loader.vue";
import pagination from "@/views/components/pagination.vue";
import modal_detail from "@/views/components/mention/modal_detail_post.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "HeadlineMediaCetak",
  title: "Headline Media Cetak Nasional | Online Media Monitoring",
  components: {
    "loader-component": loader,
    "modal-detail-component": modal_detail,
    "pagination-component": pagination,
    Multiselect,
  },
  data() {
    return {
      date: new Date(),
      is_load_media: true,
      is_loading: true,
      isShowModalDetail: false,
      id_stream: null,
      id_project: this.$store.getters.user.id_project,
      detail_key: 10,
      child_data: {},
      data: [],
      page_info: null,
      pagination_key: 0,
      per_page: this.$route.query.items ? this.$route.query.items : 10,
      media_options: [
        {
          nama: "Semua Media",
        },
      ],
      selected_media: {
        nama: "Semua Media",
      },
    };
  },
  watch: {
    $route() {
      this.getData();
    },
    per_page(item) {
      if ("items" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.items = item;
        this.$router.replace({ query: queries });
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { items: item }),
        });
      }
    },
  },
  methods: {
    today(date) {
      return gp.dateID(date);
    },
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    titleFormatter(val) {
      if (val && val.length > 100) {
        return val.substring(0, 100) + "...";
      }
      return val;
    },
    changeSelectedMedia() {
      if ("page" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        if (queries.page != 1) {
          queries.page = 1;
          this.$router.replace({ query: queries });
        }
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { page: 1 }),
        });
      }
      this.getData();
    },
    getListMedia() {
      this.is_load_media = true;
      const api =
        process.env.VUE_APP_API_URL +
        "media?page=1&items=1000&source=media_cetak&tier=1";
      this.$http
        .get(api)
        .then((res) => {
          res.data.list.forEach((el) => {
            const media = {
              nama: el.nama,
            };
            this.media_options.push(media);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_load_media = false;
        });
    },
    getData() {
      this.is_loading = true;
      var params = this.$route.query;
      if (this.selected_media.nama != "Semua Media") {
        params.account = this.selected_media.nama;
      } else {
        delete params.account;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = `${process.env.VUE_APP_API_URL}headlines/media-cetak?${query}`;
      this.$http
        .get(api)
        .then((res) => {
          this.data = res.data.posts;
          this.page_info = res.data.page_info[0];
          this.pagination_key++;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    scrollLeft() {
      const scroll_container = document.getElementById("scroll-container");
      const current_scroll = scroll_container.scrollLeft;
      scroll_container.scrollTo({
        left: current_scroll - 400,
        behavior: "smooth",
      });
    },
    scrollRight() {
      const scroll_container = document.getElementById("scroll-container");
      const current_scroll = scroll_container.scrollLeft;
      scroll_container.scrollTo({
        left: current_scroll + 400,
        behavior: "smooth",
      });
    },
    showDetailModal: function (data) {
      this.id_stream = data._id.$oid;
      this.child_data = data;
      this.detail_key++;
      this.isShowModalDetail = true;
    },
    closeModalDetail: function () {
      this.isShowModalDetail = false;
    },
    imgError: function () {
      event.target.src = "/assets/img/web/imgerror.png";
    },
    writeContent(text) {
      var new_text = text;
      new_text = new_text.replace(/\n/g, "<br />");
      return new_text;
    },
    limitContent(text) {
      if (text.length > 350) {
        return text.substring(0, 350) + "...";
      }
      return text;
    },
  },
  mounted() {
    this.getListMedia();
    this.getData();
  },
};
</script>
<style scoped>
.scroll-container {
  width: 100%;
  overflow-x: auto;
  transition: scroll-behavior 0.5s;
}
.scroll-container::-webkit-scrollbar {
  display: none;
}
.content-wrap {
  width: 10rem !important;
}
</style>